namespace RioERP.Web.Enums {
    export enum ShippingProviderType {
        Self = 1,
        Vendor = 2
    }
    Serenity.Decorators.registerEnumType(ShippingProviderType, 'RioERP.Web.Enums.ShippingProviderType');
}
